<script>
	export let params = {}

	import {createEventDispatcher, onMount} from 'svelte';
	import {replace} from 'svelte-spa-router';
	import TBoxInterno from '../templates/TBoxInterno.svelte';
	import {
		API,
		cabecalhoPadraoRequisicao,
		converterJSONParaCSV,
		StatusHttp,
		TextoFeedback,
		TipoEvento,
		verificarSessionStorage
	} from '../../utils';

	const dispatch = createEventDispatcher();
	let listagemClassificacao = [];
	let dataCache = null;
	let tipoObjetoClassificacao;
	let nomeChaveLS = "";

	onMount(async () => {
		tipoObjetoClassificacao = params.tipo;

		nomeChaveLS = `AVAL_CLASSIFICACAO_OBJETOS_CACHE_${tipoObjetoClassificacao}`;

		if (verificarSessionStorage('AVAL_TOKEN')) {
			if (localStorage.getItem(nomeChaveLS) == null)
				carregarClassificacaoAPI();
			else {
				let classificacaoCache = JSON.parse(localStorage.getItem(nomeChaveLS));
				listagemClassificacao = classificacaoCache.listagemClassificacao;
				dataCache = classificacaoCache.dataCache;
			} 
				
		} else replace("/login");
	});

	const exportarListagemCSV = async () => {
		let cacheClassificacao = localStorage.getItem(nomeChaveLS);
		
		if (cacheClassificacao == null)
			alert('Cache não gerado. Tente novamente.');
		else {
			let { listagemClassificacao } = JSON.parse(cacheClassificacao);
			converterJSONParaCSV(listagemClassificacao, 'CLASSIFICACAO' + new Date().toLocaleString(), true);
		}
	};

	const carregarClassificacaoAPI = async () => {
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Carregando dados ...',
		});

		let endpointClassificacao = tipoObjetoClassificacao == 'PROJETO' ? 'classificacao-projetos' : 'classificacao-apresentacoes';

		const resposta = await fetch(API(endpointClassificacao), {
			method: 'GET',
			headers: cabecalhoPadraoRequisicao()
		}).catch(erros => {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: TextoFeedback.ERRO_REQUISICAO
			});

			replace("/login");
			console.log(erros);
		});
		
		const json = await resposta.json();

		if (resposta.status == StatusHttp.OK) {
			listagemClassificacao = [... json.dados];

			if (listagemClassificacao.length == 0) {
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: 'Aviso',
					conteudo: 'Nenhuma informação encontrada.'
				});
				
				replace("/painel/classificacao");
			} else {
				localStorage.setItem(nomeChaveLS, JSON.stringify({
					listagemClassificacao: listagemClassificacao,
					dataCache: new Date().toLocaleString() 
				}));
			}
		} else {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: json?.mensagem
			});
			
			replace("/painel");
		}

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
	}
</script>

<TBoxInterno 
	titulo="Classificação ANO {localStorage.getItem('AVAL_CONFIG_APP_ANOBASE')}" 
	subtitulo="{dataCache == null ? '...' : 'Classificação armazenada em cache em ' + dataCache}"
	largura="12" 
	icone="trofeu"
	deslocamento="0">

	<div class="notification is-link is-light">
		A classificação é armazenada em cache para evitar sobrecarga ao servidor (back-end). Para atualizar a listagem de classificação, vá em MENU > PAINEL > CONFIGURAÇÕES > LIMPAR CACHE. Será necessário realizar novo login.
		<button class="button" on:click|preventDefault={exportarListagemCSV}>Clique aqui para exportar para CSV</button>.
	</div>

	{#if tipoObjetoClassificacao == 'PROJETO'}
	<p class="mb-4 is-size-4">Listagem classificação de PROJETOS</p>

	<table class="table is-fullwidth is-hoverable">
		<thead>
			<tr>
				<th>Projeto</th>
				<th>Pontuação</th>
				<th>Total de Avaliações</th>
				<th>Modalidade</th>
				<th>Área</th>
				<th>Qtd. Bolsas</th>
			</tr>
		</thead>
		<tbody>
			{#each listagemClassificacao as projeto}
			<tr>
				<td>
					<a href="#/projeto/visualizar/{projeto.codigo}">{ projeto.codigo }</a>
					→
					{ projeto.titulo }
				</td>
				<td>{ projeto.pontuacao }</td>
				<td>{ projeto.total_avaliacoes }</td>
				<td>{ projeto.modalidade }</td>
				<td>{ projeto.alocacao }</td>
				<td>{ projeto.total_bolsas }</td>
			</tr>
			{/each}
		</tbody>
	</table>
	{:else}
	<p class="mb-4 is-size-4">Listagem classificação de APRESENTAÇÕES</p>
	
	<table class="table is-fullwidth is-hoverable">
		<thead>
			<tr>
				<th>Inscrição</th>
				<th>Projeto</th>
				<th>Pontuação</th>
				<th>Total de Avaliações</th>
				<th>Modalidade</th>
				<th>Área</th>
				<th>Qtd. Bolsas</th>
			</tr>
		</thead>
		<tbody>
			{#each listagemClassificacao as apresentacao}
			<tr>
				<td>
					<a href="#/apresentacao/visualizar/{apresentacao.id}/{apresentacao.codigo}">{ apresentacao.inscricao }</a>
				</td>
				<td>
					<a href="#/projeto/visualizar/{apresentacao.codigo}">{ apresentacao.titulo }</a>
				</td>
				<td>{ apresentacao.pontuacao }</td>
				<td>{ apresentacao.total_avaliacoes }</td>
				<td>{ apresentacao.modalidade }</td>
				<td>{ apresentacao.alocacao }</td>
				<td>{ apresentacao.total_bolsas }</td>
			</tr>
			{/each}
		</tbody>
	</table>
	{/if}
</TBoxInterno>
